import { pathPortal } from "Path";

/**
 * True when `pathname` is `/portal` itself or any nested portal route
 * (`/portal/sede/:id`, `/portal/solicitudes`, etc).
 */
export const isPortalPath = (pathname) => {
  if (!pathname) return false;
  return pathname === pathPortal.home || pathname.startsWith(`${pathPortal.home}/`);
};

/**
 * A customer-portal user (JWT payload carries `customer`) must never reach
 * an internal-only route. Returns true when the current path should be
 * redirected to the portal home.
 */
export const shouldRedirectToPortal = (user, pathname) => {
  if (!user?.customer) return false;
  return !isPortalPath(pathname);
};
